import { Alert } from "@/shared/ui/core";
import { ResendVerification } from "./ResendVerification";

export interface UnverifiedEmailNoticeProps {
  /** El correo con el que se acaba de intentar entrar, ya normalizado. */
  email: string;
}

/**
 * Lo que ve quien intenta entrar con una cuenta cuyo correo no está
 * verificado.
 *
 * Es un aviso DISTINTO del error de credenciales, y esa es la razón de que
 * exista: "el correo o la contraseña no son correctos" mandaría a alguien
 * a probar contraseñas que están perfectamente bien, una tras otra, hasta
 * que el servidor le bloquee la cuenta por intentos. Aquí el problema se
 * nombra y se resuelve en el mismo sitio.
 *
 * El correo se enseña porque es la mitad de la respuesta: quien no
 * encuentra el mensaje muchas veces lo mandó a una dirección con una letra
 * de más.
 *
 * El aviso va COMO `explanation` de `ResendVerification` y no encima de
 * él: así, cuando el correo sale, este texto cede su sitio a la
 * confirmación en vez de apilarse con ella. Los dos dirían lo mismo, y dos
 * avisos seguidos obligan a leer ambos para saber cuál manda.
 */
export function UnverifiedEmailNotice({ email }: UnverifiedEmailNoticeProps) {
  return (
    <div className="mb-4">
      <ResendVerification
        email={email}
        submitLabel="Reenviar el enlace"
        // Secundario: "Iniciar sesión" sigue siendo la acción principal del login.
        variant="secondary"
        explanation={
          <Alert variant="warning" title="Falta verificar tu correo">
            Abre el enlace que mandamos a{" "}
            <span className="font-medium">{email}</span>, o pide uno nuevo.
          </Alert>
        }
      />
    </div>
  );
}
